'use strict';

let regexp = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

window.AdFinanceFrontendBundleFormValidatorEmail = function() {
    this.message = '';

    this.validate = function (value) {
        let errors = [];

        if (FpJsFormValidator.isValueEmty(value)) {
            return errors;
        }

        if (value === '@' || !regexp.test(value)) {
            errors.push(this.message.replace('{{ value }}', FpJsBaseConstraint.formatValue(value)));
        }

        return errors;
    }
};


window.AdFinanceFrontendBundleFormValidatorEmail = function() {
    this.message = '';

    this.validate = function (value) {
        let errors = [];

        if (FpJsFormValidator.isValueEmty(value)) {
            return errors;
        }

        if (value === '@' || !regexp.test(value)) {
            errors.push(this.message.replace('{{ value }}', FpJsBaseConstraint.formatValue(value)));
        }

        return errors;
    }
};


// WEBPACK FOOTER //
// ./app/Resources/assets/js/lib/formValidator/adfinance.email.js